import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import actions from './catalogs.actions';
import catalogsAdapter from './catalogs.adapter';
import utils from './catalogs.utils';

import type { LoadingStatus } from 'types/common_types';
import type { RawCatalogAPIData } from 'types/catalog_types';

type CatalogSliceInitialState = {
  status: LoadingStatus;
};

const { getAllShallow, getAllDeep } = actions;

const initialState: CatalogSliceInitialState = {
  status: 'idle',
};

const catalogs = createSlice({
  name: 'catalogs',
  initialState: catalogsAdapter.getInitialState(initialState),
  reducers: {
    addMany(state, { payload }: PayloadAction<RawCatalogAPIData[]>) {
      const formatted = payload.map(utils.flattenCatalogTemplates);
      return catalogsAdapter.addMany(state, formatted);
    },
    reset() {
      return catalogsAdapter.getInitialState(initialState);
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAllShallow.pending, (state) => {
        return { ...state, status: 'loading' };
      })
      .addCase(getAllShallow.fulfilled, (state, { payload }) => {
        const formatted = payload.map(utils.flattenCatalogTemplates);
        const update = catalogsAdapter.addMany(state, formatted);
        update.status = 'idle';
        return update;
      })
      .addCase(getAllShallow.rejected, (state) => {
        return { ...state, status: 'error' };
      })
      .addCase(getAllDeep.pending, (state) => {
        return { ...state, status: 'loading' };
      })
      .addCase(getAllDeep.fulfilled, (state, { payload }) => {
        const formatted = payload.map(utils.flattenCatalogTemplates);
        const update = catalogsAdapter.setMany(state, formatted);
        update.status = 'idle';
        return update;
      })
      .addCase(getAllDeep.rejected, (state) => {
        return { ...state, status: 'error' };
      });
  },
});

export default catalogs;
